import React, { ReactElement, useEffect, useState } from 'react';
import { useParams, Redirect, Link } from 'react-router-dom';
import { API } from '../../../services/api';
import { SeminarInterface } from '../../../interfaces/SeminarInterface';
import Loading from '../../../components/Loading';
import { PaginatedListInterface } from '../../../interfaces/PaginatedList';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import de from 'date-fns/locale/de';

registerLocale('de', de);

export default (): ReactElement => {
  const [seminar, setSeminar] = useState<SeminarInterface>();
  const [redirect, setRedirect] = useState<boolean>(false);

  const [hosts, setHosts] = useState<PaginatedListInterface<any>>();

  const [title, setTitle] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [scheduledStart, setScheduledStart] = useState<Date>(new Date());
  const [length, setLength] = useState<number>(0);
  const [hostId, setHostId] = useState<string | undefined>();

  const { id }: any = useParams();

  useEffect(() => {
    (async () => {
      const result = await API.get(`host/seminars/${id}`);
      setSeminar(result);
      setTitle(result.title);
      setDescription(result.description);
      setScheduledStart(result.scheduledStart);
      setLength(result.length);
      setHostId(result.hostId);

      const hostsResult = await API.get(`host`);
      setHosts(hostsResult);
    })();
  }, []);

  const handleSave = async () => {
    await API.patch(`host/seminars/${id}`, {
      title,
      description,
      scheduledStart,
      length,
      hostId,
    });
    setRedirect(true);
  };

  if (redirect) return <Redirect to={`/seminars/seminars/${id}`} />;

  if (!seminar || !hosts) return <Loading />;

  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1>{seminar?.title}</h1>
          </div>
          <div
            className="col-sm-6"
            style={{
              textAlign: 'right',
            }}
          >
            <Link to={`/seminars/seminars/${seminar.id}`}>
              <button type="button" className="btn btn-secondary btn-sm">
                Abbrechen
              </button>
            </Link>
            &nbsp; &nbsp; &nbsp;
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={handleSave}
            >
              Speichern
            </button>
          </div>
        </div>
        <div>
          <div className="card card-primary">
            <div className="card-body">
              <div className="form-group">
                <label>Titel</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setTitle(e.target.value)}
                  value={title}
                />
              </div>

              <div className="form-group">
                <label>Beschreibung</label>
                <textarea
                  className="form-control"
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                />
              </div>

              <div className="form-group">
                <label>Geplanter Start</label>
                <br />
                <DatePicker
                  selected={scheduledStart}
                  onChange={(date) => setScheduledStart(date as Date)}
                  showTimeSelect
                  dateFormat="Pp"
                  locale="de"
                />
              </div>

              <div className="form-group">
                <label>Dauer in Minuten</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setLength(parseInt(e.target.value, 10))}
                  value={length}
                />
              </div>

              <div className="form-group">
                <label>Seminarleiter</label>
                <select
                  className="form-control"
                  onChange={(e) => setHostId(e.target.value)}
                  value={hostId}
                >
                  {hosts.items.map((host, key) => (
                    <option key={key} value={host.id}>
                      {host.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
